module.exports = __webpack_public_path__ + "static/media/legende_construction.debcc937.svg";